import { motion } from "framer-motion";

export function GreenScreenMascot() {
    return (
        <motion.div
            className="
                pointer-events-none
                fixed
                bottom-0
                right-0
                z-[30]
                h-[28vh]
                w-auto
            "

            initial={{
                opacity: 1
            }}

            animate={{
                opacity: 0
            }}

            transition={{
                delay: 10,
                duration: 2.5,
                ease: "easeOut"
            }}
        >

            <motion.video
                autoPlay
                muted
                playsInline
                preload="auto"

                className="
                    h-full
                    w-auto
                "

                initial={{
                    x: "10vw"
                }}

                animate={{
                    x: "-36.5vw"
                }}

                transition={{
                    duration: 2.8,
                    ease: "easeOut"
                }}
            >
                <source
                    src="/assets/Green_Chroma_Mascot.webm"
                    type="video/webm"
                />

            </motion.video>

        </motion.div>
    );
}